<template>
  <div class="content-item">
    <cta-button v-if="content.type === 'button'" :content="content"></cta-button>
    <footnotes v-if="content.type === 'footnotes'" :content="content"></footnotes>
    <text-block v-if="content.type === 'text-block'" :content="content"></text-block>
    <quotation v-if="content.type === 'quotation'" :content="content"></quotation>
    <sub-chart v-if="content.type === 'sub-chart'" :content="content"></sub-chart>
    <sub-indicator v-if="content.type === 'sub-indicator'" :content="content"></sub-indicator>
  </div>
</template>

<script>
  import CtaButton from '@/components/ContentItems/CtaButton/CtaButton'
  import Footnotes from '../ContentItems/Footnotes/Footnotes'
  import TextBlock from '../ContentItems/TextBlock/TextBlock'
  import Quotation from '../ContentItems/Quotation/Quotation'
  import SubChart from '../ContentItems/SubChart/SubChart'
  import SubIndicator from '../ContentItems/SubIndicator/SubIndicator'

  export default {
    name: 'ContentItem',
    components: {
      CtaButton,
      Footnotes,
      TextBlock,
      Quotation,
      SubChart,
      SubIndicator
    },
    props: {
      "content": {
        type: Object,
        required: true
      }
    }
  }
</script>

<style src="./ContentItem.scss" lang="scss"></style>
